import React from "react";
import { useTranslation } from "next-i18next";
import Modal from "./Modal";
import { useSignUpPromotion } from "../../hooks/useSignUpPromotion";
import { useGlobalState } from "../../context/GlobalStateContext";

interface SignUpPromotionModalProps {
  enabled?: boolean;
}

const SignUpPromotionModal: React.FC<SignUpPromotionModalProps> = ({ enabled = true }) => {
  const { t: translate, ready } = useTranslation("signup_promotion");
  const { isLoggedIn } = useGlobalState();
  const { showSignUpPopup, handleClose, handleSignUp } = useSignUpPromotion({
    isLoggedIn,
    enabled,
  });
  if (!ready) {
    return null;
  }

  return (
    <Modal isOpen={showSignUpPopup} onClose={handleClose} maxWidth="max-w-md">
      <div className="w-full">
        <div className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="w-16 h-16 bg-[#233377] rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
          </div>
          <h2
            id="signup-modal-title"
            className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 rtl:text-right ltr:text-left"
          >
            {translate("title")}
          </h2>

          <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
            {translate("body")}
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleSignUp}
              className="flex-1 bg-[#233377] hover:bg-[#1a2557] text-white font-semibold rounded-lg px-6 py-3 transition-colors duration-200"
            >
              {translate("signup_button")}
            </button>
            <button
              onClick={handleClose}
              className="flex-1 border border-sky-900  text-sky-900 font-semibold rounded-lg px-6 py-3 transition-colors duration-200"
            >
              {translate("cancel_button")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SignUpPromotionModal;
